function handleAlignUpdate(value, objId, componentDimensions, setComponentDimensions, activeDisplay) {
    let newObjs = [ ...componentDimensions ];
    let obj = newObjs.find(a => a.id === objId);
    let activeDisplay_width_px = activeDisplay.width_px;
    let activeDisplay_height_px = activeDisplay.height_px;

    // Compute rotated bounding box offsets (rotation around top-left origin)
    const rad = (obj.rotation || 0) * Math.PI / 180;
    const cos = Math.cos(rad);
    const sin = Math.sin(rad);
    const w = obj.width;
    const h = obj.height;

    // Four corners relative to top-left origin after rotation
    const cornersX = [0, w * cos, -h * sin, w * cos - h * sin];
    const cornersY = [0, w * sin, h * cos, w * sin + h * cos];

    const minX = Math.min(...cornersX);
    const maxX = Math.max(...cornersX);
    const minY = Math.min(...cornersY);
    const maxY = Math.max(...cornersY);

    const bboxW = maxX - minX;
    const bboxH = maxY - minY;

    switch (value) {
      case "left":
        obj.x_pos = -minX;
        setComponentDimensions(newObjs);
        break;
      case "right":
        obj.x_pos = activeDisplay_width_px - maxX;
        setComponentDimensions(newObjs);
        break;
      case "center_w":
        obj.x_pos = activeDisplay_width_px / 2 - (minX + maxX) / 2;
        setComponentDimensions(newObjs);
        break;
      case "top":
        obj.y_pos = -minY;
        setComponentDimensions(newObjs);
        break;
      case "center_v":
        obj.y_pos = activeDisplay_height_px / 2 - (minY + maxY) / 2;
        setComponentDimensions(newObjs);
        break;
      case "bottom":
        obj.y_pos = activeDisplay_height_px - maxY;
        setComponentDimensions(newObjs);
        break;
      default:
        break;
    }
  }

  export default handleAlignUpdate;